import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";

// initial state
const state = {
  userData: null,
  token: null,
  roles: [],
};

export default {
  state,
  getters,
  actions,
  mutations,
};
